import { useState, useEffect } from 'react';
import {
    Stethoscope, Baby, Monitor, FileText, Activity, Users,
    Heart, Dna, Brain, Shield, Eye, Microscope
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { API_URL } from '../config/api';
import './Services.css';

const ICON_MAP = {
    Stethoscope, Baby, Monitor, FileText, Activity, Users,
    Heart, Dna, Brain, Shield, Eye, Microscope,
    // Backend/editor icon keys
    stethoscope: Stethoscope,
    baby: Baby,
    monitor: Monitor,
    'file-text': FileText,
    activity: Activity,
    users: Users,
    heart: Heart,
    dna: Dna,
    brain: Brain,
    shield: Shield,
    eye: Eye,
    microscope: Microscope,
    layers: Monitor,
    'heart-pulse': Heart,
    pill: Activity,
    clipboard: FileText
};

const Services = () => {
    const [content, setContent] = useState({});
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchContent();
        fetchServices();
    }, []);

    const fetchContent = async () => {
        try {
            const response = await fetch(`${API_URL}/content/services`);
            const data = await response.json();
            if (data.success) setContent(data.data);
        } catch (error) {
            console.error('Error fetching content:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchServices = async () => {
        try {
            const response = await fetch(`${API_URL}/site-services`);
            const data = await response.json();
            if (data.success) setServices(data.data || []);
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    };

    const getIcon = (iconName) => {
        const IconComponent = ICON_MAP[iconName] || Stethoscope;
        return <IconComponent size={40} />;
    };

    const getImageUrl = (url) => {
        if (!url) return '';
        if (url.startsWith('http://') || url.startsWith('https://')) return url;
        return `${API_URL}${url}`;
    };

    if (loading) {
        return <div style={{ padding: '40px', textAlign: 'center' }}>Cargando...</div>;
    }

    // Fallback to static services if none in DB
    const defaultIcons = [Stethoscope, FileText, Users, Baby, Monitor, Activity];
    const displayServices = services.length > 0
        ? services
        : [1, 2, 3, 4, 5, 6].map((num, index) => ({
            id: num,
            icon: defaultIcons[index].name,
            title: content[`service_${num}_title`] || `Servicio ${num}`,
            description: content[`service_${num}_description`] || 'Descripción del servicio'
        }));

    return (
        <div className="services-page">
            <section className="page-header">
                <div className="container">
                    <h1 className="page-title">{content['page_title'] || 'Nuestros Servicios'}</h1>
                    <p className="page-subtitle">
                        {content['page_subtitle'] || 'Atención integral para el diagnóstico y manejo de condiciones genéticas.'}
                    </p>
                </div>
            </section>

            <section className="section container">
                <div className="services-grid">
                    {displayServices.map((service) => (
                        <div key={service.id} className="service-card">
                            <h3 className="service-title">{service.title}</h3>
                            <div className="service-icon-wrapper">
                                {service.image_url ? (
                                    <img src={getImageUrl(service.image_url)} alt={service.title} />
                                ) : (
                                    getIcon(service.icon)
                                )}
                            </div>
                            <p className="service-description">{service.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="section bg-light cta-section-small">
                <div className="container text-center">
                    <h2>{content['cta_title'] || '¿No estás seguro de qué servicio necesitas?'}</h2>
                    <p>{content['cta_text'] || 'Contáctanos para recibir orientación personalizada.'}</p>
                    <Link to="/contacto" className="btn btn-primary">
                        Contactar Ahora
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Services;

